import { render } from "./indexMatrixView.vue?vue&type=template&id=fa656c50"
import script from "./indexMatrixView.vue?vue&type=script&lang=js"
export * from "./indexMatrixView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__